import el from "@cypherpotato/el";
import { api } from "../api";
import { formatDateTime } from "../ui/format";
import { runOperation } from "../ui/operation";
import { ModelBadge } from "./model-icon";
import { Table, TableBody, TableCell, TableRow } from "./table";
import { MutedText } from "./text";

export function GatewayPickerControl({ allowNone = false, value }) {

    const gateways = el.state.create([]);
    const selectedGateway = el.state.create(value);

    runOperation("Fetching gateways...", async () => {
        const response = await api.getJson("/api/v1/ai-gateways");
        gateways.value = response.data;
    });

    return el.state.listening([gateways, selectedGateway], () =>
        Table(
            {
                $properties: {
                    value: {
                        get() {
                            return selectedGateway.value;
                        },
                        set(value) {
                            selectedGateway.value = value;
                        }
                    }
                },
                classList: ["selectable"]
            },
            TableBody(
                allowNone && TableRow(
                    TableCell("(None)"),
                    TableCell(),
                    TableCell(),
                    {
                        onClick() {
                            selectedGateway.value = null;
                        },
                        classList: [selectedGateway.value === null && "highlighted"]
                    }
                ),
                gateways.value.map(gateway =>
                    TableRow(
                        TableCell(gateway.name),
                        TableCell(
                            el("small", MutedText("Created at")),
                            el("div", formatDateTime(gateway.createdAt))
                        ),
                        TableCell(
                            ModelBadge(gateway.modelName)
                        ),
                        {
                            onClick() {
                                selectedGateway.value = gateway.id;
                            },
                            classList: [selectedGateway.value === gateway.id && "highlighted"]
                        }
                    )
                )
            )
        )
    );
}